<template>
  <span :style="{'display': block? 'block': 'inline'}" @click="goToUpgrade()">
    <slot></slot>
  </span>
</template>

<script>
import {setRedirectToAfterUpgrade} from "@/shared/utils";
import {config} from "@/config/config";

export default {
  name: "UpgradeAction",
  props: ['redirectTo', 'block'],
  methods: {
    goToUpgrade() {

      let _redirectTo = {
        name: this.$route.name,
        params: this.$route.params,
      };

      if( this.redirectTo === 'new-valuation'){
        _redirectTo = {
          name: 'calculator'
        };
      }
      else if( this.redirectTo === 'ics_calculator'){
        _redirectTo = {
          name: 'ics_calculator'
        };
      }
      else if( this.redirectTo === 'dashboard'){
        _redirectTo = {
          name: 'dashboard'
        };
      }

      setRedirectToAfterUpgrade(_redirectTo);
      this.$router.push({name: 'plans'});
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
